import { z } from 'zod';
import { inferPaginatedApiResponse } from './infer-api';

export const CustomerAllowedEmailDomainsSchema = z.object({
  id: z.number(),
  customerId: z.number(),
  accountId: z.string().max(50),
  allowedEmailDomain: z.string().trim().min(1).max(300),
});
export type CustomerAllowedEmailDomainsDto = z.infer<typeof CustomerAllowedEmailDomainsSchema>;

export const CreateCustomerAllowedEmailDomainsSchema = CustomerAllowedEmailDomainsSchema.omit({
  id: true,
});
export type CreateCustomerAllowedEmailDomainsDto = z.infer<
  typeof CreateCustomerAllowedEmailDomainsSchema
>;

export const UpdateCustomerAllowedEmailDomainsSchema = CustomerAllowedEmailDomainsSchema.omit({
  id: true,
  accountId: true,
  customerId: true,
});
export type UpdateCustomerAllowedEmailDomainsDto = z.infer<
  typeof UpdateCustomerAllowedEmailDomainsSchema
>;

export const GetCustomerAllowedEmailDomainsResponseSchema = inferPaginatedApiResponse(
  z.array(CustomerAllowedEmailDomainsSchema),
);
export type GetCustomerAllowedEmailDomainsResponseDto = z.infer<
  typeof GetCustomerAllowedEmailDomainsResponseSchema
>;
